import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Barcode } from '@capacitor-mlkit/barcode-scanning';
import { ModalController, Platform } from '@ionic/angular';

import { BarcodeScanningModalComponent } from './barcode-scan-modal-component';

@Component({
  selector: 'swodoc-node-barcode',
  templateUrl: 'swodoc-node-barcode.html',
  styleUrls: ['swodoc-node-barcode.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeBarcode implements OnInit {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('input', { static: true }) public input: any;
  public isMobile: boolean;

  constructor(private _modalCtrl: ModalController, private _platform: Platform) {}

  async ngOnInit() {
    this.isMobile = this._platform.is('hybrid');
  }

  get text(): string {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      return this.node.responses[0].value;
    }

    return '';
  }
  set text(value: string) {
    this.node.responses = this.node.responses || [];
    if (this.node.responses.length === 0) {
      this.node.responses.push({ value });
    } else {
      this.node.responses[0] = { value };
    }
    if (this.node.responses && this.node.responses.length > 1 && this.node.responses[1].value) {
      this.node.responses[1].value = undefined;
    }
    this.changed.emit(this.node);
  }

  setFocus() {
    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 0);
  }

  /**
   * open modal that scans barcode
   * on capacitor with ionic we need a workaround in code because web view is in foreground and scanner is not visble
   */
  async scan() {
    const scanDialogue = await this._modalCtrl.create({
      component: BarcodeScanningModalComponent,
      // Set `visibility` to `visible` to show the modal (see global.scss)
      cssClass: 'barcode-scanning-modal',
      showBackdrop: false,
      componentProps: {
        // you could set certain formats or lensFacing (front/back) here
        // formats: formats,
        // lensFacing: lensFacing,
      },
    });

    scanDialogue.onDidDismiss().then(result => {
      const barcode: Barcode | undefined = result.data?.barcode;
      if (barcode) {
        this.text = barcode.displayValue;
      }
    });
    scanDialogue.present();
  }
}
